import { Box, Grid2, Typography } from '@mui/material';
import moment from 'moment/moment';
import Constant from '../../../../../Utils/Constant';
import Skeleton from 'react-loading-skeleton';
import NoDataImg from '../../../../../Components/NoDataFound/NoDataFound';
import { useNavigate } from 'react-router-dom';
const InterpreterLegalDocumentTranslator = (props) => {
    const { interpreterLegalDocumentT, isLoading } = props;
    const navigate = useNavigate();
    return (
        <Box sx={{
            width: '100%',
            padding: '10px 10px 0px 10px',
            height: 'calc(100vh - 250px)',
            overflowY: 'auto',

            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': { display: 'none' },
        }}>
            <Grid2 container spacing={2} height={
                interpreterLegalDocumentT && interpreterLegalDocumentT?.length > 0 ? "auto" : "100%"
            }>
                {isLoading ? (
                    <>
                        {[...Array(5)].map((_, index) => (
                            <Grid2 size={{ xs: 12, md: 6, lg: 6, xl: 4 }} key={index}>
                                <Skeleton variant="circle" height={200} />
                            </Grid2>

                        ))}
                    </>
                ) : interpreterLegalDocumentT?.length > 0 ? interpreterLegalDocumentT?.map((elem, index) => {
                    return (
                        <Grid2 key={index} size={{ xs: 12, md: 6, lg: 6, xl: 4 }}>
                            <Box sx={{
                                background: "rgba(250, 250, 250, 1)",
                                padding: '15px',
                                borderRadius: '15px',
                                width: '100%',
                                cursor: 'pointer',
                                ":hover":{
                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                                    border: "1px solid rgba(0, 151, 178, 0.2)",
                                }
                            }} onClick={() => {
                                navigate("/admin/interpreter-session-details", {
                                    state: {
                                        interpreterSessionID: elem?.id,
                                    }
                                })
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}>
                                    <Typography variant="h6"
                                        sx={{
                                            color: "#000",
                                            fontSize: { xs: '16px', md: "18px" },
                                            fontWeight: "500",
                                            fontFamily: "Outfit",
                                            paddingLeft: '10px',
                                            color: "rgba(8, 85, 127, 1)"
                                        }}>
                                        {elem?.title}
                                    </Typography>
                                    <Typography sx={{
                                        background: "rgba(0, 151, 178, 0.2)",
                                        padding: '4px 10px',
                                        borderRadius: '22px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        fontFamily: "Outfit",
                                        width: 'fit-content',
                                        color: 'rgba(2, 56, 85, 1)'
                                    }}>
                                        {elem?.service_type ? elem?.service_type === 1
                                            ? "Onsite"
                                            : elem?.service_type === 2
                                                ? "Virtual"
                                                : "Both" : "N/A"}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    padding: '10px 0px 0px 0px'
                                }}>
                                    <Typography variant="h6"
                                        sx={{
                                            color: "rgba(0, 0, 0, 1)",
                                            fontSize: { xs: '14px', md: "14px" },
                                            fontWeight: "500",
                                            fontFamily: "Outfit",
                                            paddingLeft: '10px'
                                        }}>Location:</Typography>
                                    <Typography sx={{
                                        padding: '4px 10px',
                                        borderRadius: '22px',
                                        fontSize: '12px',
                                        fontFamily: "Outfit",
                                    }}>
                                        {elem?.location}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                }}>
                                    <Typography variant="h6"
                                        sx={{
                                            color: "rgba(0, 0, 0, 1)",
                                            fontSize: { xs: '14px', md: "14px" },
                                            fontWeight: "500",
                                            fontFamily: "Outfit",
                                            paddingLeft: '10px'
                                        }}>Date:</Typography>
                                    <Typography sx={{
                                        padding: '4px 10px',
                                        borderRadius: '22px',
                                        fontSize: '12px',
                                        fontFamily: "Outfit",
                                    }}>
                                        {moment(elem?.date_time).format('DD/MM/YYYY')}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                }}>
                                    <Typography variant="h6"
                                        sx={{
                                            color: "rgba(0, 0, 0, 1)",
                                            fontSize: { xs: '14px', md: "14px" },
                                            fontWeight: "500",
                                            fontFamily: "Outfit",
                                            paddingLeft: '10px'
                                        }}>Language :</Typography>
                                    <Typography sx={{
                                        padding: '4px 10px',
                                        borderRadius: '22px',
                                        fontSize: '12px',
                                        fontFamily: "Outfit",
                                    }}>
                                        {elem?.from_language || "N/A"} → {elem?.to_language || "N/A"}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                }}>
                                    <Typography variant="h6"
                                        sx={{
                                            color: "rgba(0, 0, 0, 1)",
                                            fontSize: { xs: '14px', md: "14px" },
                                            fontWeight: "500",
                                            fontFamily: "Outfit",
                                            paddingLeft: '10px'
                                        }}>Time:</Typography>
                                    <Typography sx={{
                                        padding: '4px 10px',
                                        borderRadius: '22px',
                                        fontSize: '12px',
                                        fontFamily: "Outfit",
                                    }}>
                                        {moment(elem?.date_time).local().format('hh:mm A')}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                }}>
                                    <Typography variant="h6"
                                        sx={{
                                            color: "rgba(0, 0, 0, 1)",
                                            fontSize: { xs: '14px', md: "14px" },
                                            fontWeight: "500",
                                            fontFamily: "Outfit",
                                            paddingLeft: '10px'
                                        }}>Total Hours:</Typography>
                                    <Typography sx={{
                                        padding: '4px 10px',
                                        borderRadius: '22px',
                                        fontSize: '12px',
                                        fontFamily: "Outfit",
                                    }}>
                                        {elem?.estimated_hours}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                }}>
                                    <Typography variant="h6"
                                        sx={{
                                            color: "rgba(0, 0, 0, 1)",
                                            fontSize: { xs: '14px', md: "14px" },
                                            fontWeight: "500",
                                            fontFamily: "Outfit",
                                            paddingLeft: '10px'
                                        }}>Payment:</Typography>
                                    <Typography sx={{
                                        padding: '4px 10px',
                                        borderRadius: '22px',
                                        fontSize: '12px',
                                        fontFamily: "Outfit",
                                    }}>
                                        {elem?.payment_status || "N/A"}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    paddingTop: "10px"
                                }}>
                                    {elem?.user_details && <>
                                        <img
                                            src={elem?.user_details?.profile_img ? `${Constant.BASE_URL}${elem?.user_details?.profile_img}` : 'https://res.cloudinary.com/do0g7smfg/image/upload/v1711695886/cld-sample-3.jpg'}
                                            alt='user' style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%'
                                            }}
                                        />
                                        <Typography sx={{
                                            padding: '4px 10px',
                                            borderRadius: '22px',
                                            fontSize: { xs: '14px', md: "14px" },
                                            fontWeight: '500',
                                            fontFamily: "Outfit",
                                        }}>
                                            {elem?.user_details?.full_name}
                                        </Typography>
                                    </>}
                                </Box>
                            </Box>
                        </Grid2>
                    )
                }) : (
                    <Grid2 size={{ xs: 12 }}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                        <NoDataImg />
                    </Grid2>
                )}
            </Grid2>

        </Box>
    );
};

export default InterpreterLegalDocumentTranslator;